/**
 * WHAT A SHOP IS TOLD WHEN A CAR WILL NOT SAVE.
 *
 * On 2026-10-19 Matt at Wrench Services added a car by its plate and the
 * job card printed the Postgres text word for word: new row for relation
 * "vehicles" violates check constraint "vehicle_is_identifiable". He
 * photographed it and texted it to Anthony. 0230 fixed the plate case;
 * this makes sure any check the vehicles table refuses on reads as an
 * instruction, never as the database talking.
 *
 * 23514 is Postgres's check_violation. Anything else (a lost connection,
 * a policy) keeps its own text, because that is the clue somebody needs.
 */
export const CAR_NEEDS_A_NAME = "Add a make, VIN or plate.";

export function carSaveRefusal(
  lead: string,
  error: { code?: string | null; message?: string | null },
): string {
  const text = error.message ?? "";
  if (error.code === "23514" || /check constraint/i.test(text)) {
    return `${lead}. ${CAR_NEEDS_A_NAME}`;
  }
  return `${lead}: ${text || "no reason given"}`;
}
